<template>
  <div>
    <vk-offcanvas flipped overlay stuck :show.sync="addOffCanvas">
      <div style="height: 100%; text-align: left;">
        <vk-offcanvas-close @click="toggleAdd"></vk-offcanvas-close>
        <h3>Add</h3>
        <hr />
        <div>
          <form>
            <div class="form-group" style="padding: 0;">
              <label style="text-align: left; padding: 0;" for="deviceID"
                >Installation</label
              >
              <el-autocomplete
                style="width: 100%;"
                id="customer-contact"
                class="inline-input"
                v-model="form.installation"
                :fetch-suggestions="installationSearch"
                placeholder="Search contact"
                prefix-icon="el-icon-search"
                @select="contactSelected"
              ></el-autocomplete>
            </div>
            <div
              class="form-group"
              style="display: flex; flex-flow: column; padding: 0;"
            >
              <label style="text-align: left; padding: 0;" for="filterDate"
                >Contract Period</label
              >
              <el-date-picker
                style="width: 100%;"
                v-model="form.filterDate"
                type="datetimerange"
                range-separator="-"
                start-placeholder="Start date"
                end-placeholder="End date"
                align="center"
              ></el-date-picker>
            </div>
            <div class="form-group" style="display: flex; flex-flow: row;">
              <div
                class="form-group"
                style="display: flex: flex-flow: column; width: 45%; margin-right: 5%;"
              >
                <label style="text-align: left; padding: 0;" for="orderVat"
                  >VAT (%)</label
                >
                <el-select
                  v-model="form.orderVat"
                  placeholder="Select"
                  style="width: 100%;"
                >
                  <el-option
                    :key="`7_5_item_vat_list`"
                    :label="`7.5%`"
                    :value="7.5"
                  ></el-option>
                  <el-option
                    :key="`0_0_item_vat_list`"
                    :label="`0.0%`"
                    :value="0.0"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="form-group"
                style="display: flex: flex-flow: column; width: 45%; margin-left: 5%;"
              >
                <label style="text-align: left; padding: 0;" for="orderVat"
                  >Payment Model</label
                >
                <el-select
                  v-model="form.paymentModel"
                  placeholder="Select Payment Model"
                  style="width: 100%;"
                  @change="noPaymentModelChange(form.paymentModel)"
                >
                  <el-option
                    :key="`5_item_paymentModel_list`"
                    :label="`LO`"
                    :value="`LO`"
                  ></el-option>
                  <el-option
                    :key="`7_item_paymentModel_list`"
                    :label="`ES`"
                    :value="`ES`"
                  ></el-option>
                </el-select>
              </div>
           <div
                class="form-group"
                style="display: flex: flex-flow: column; width: 45%; margin-left: 5%;"
              >
                <label style="text-align: left; padding: 0;" for="orderVat">Send Date</label>
              <el-date-picker
                style="width: 100%;"
                v-model="form.sendDate"
                type="datetime"
                align="center"
              ></el-date-picker>
              </div>
            </div>
            <div class="form-group" style="display: flex; flex-flow: row;">
              <div
                class="form-group"
                style="display: flex: flex-flow: column; width: 45%; margin-right: 5%;"
              >
                <label style="text-align: left; padding: 0;" for="amount"
                  >Amount</label
                >
                <el-input-number
                  style="width: 100%;"
                  id="customer-price"
                  v-model="form.amount"
                  :min="1"
                ></el-input-number>
              </div>
              <div
                class="form-group"
                style="display: flex: flex-flow: column; width: 45%; margin-left: 5%;"
              >
                <label style="text-align: left; padding: 0;" for="amount"
                  >Installation Location</label
                >
                <el-input
                  placeholder="Location"
                  v-model="form.location"
                ></el-input>
              </div>
            </div>
            <div class="form-group">
              <label style="text-align: left; padding: 0;" for="title"
                >Title</label
              >
              <el-input
                v-model="form.title"
                placeholder="ARNERGY 5000 - ENERGY AS A SERVICE SUBSCRIPTION"
                id="title"
              ></el-input>
            </div>
            <div class="form-group">
              <label style="text-align: left; padding: 0;" for="description"
                >Description</label
              >
              <el-input
                type="textarea"
                :rows="2"
                v-model="form.description"
                placeholder="Design, Installation, Commissioning and Managed Service of a 4.5kWp Solar PV System with 10.8kWh Lithium-ion battery Storage"
                id="description"
              ></el-input>
            </div>
            <div class="form-group" style="display: flex; flex-flow: row;">
              <div
                class="form-group"
                style="display: flex: flex-flow: column; width: 45%; margin-right: 5%;"
              >
                <label style="text-align: left; padding: 0;" for="description"
                  >Contact Address</label
                >
                <el-input
                  type="textarea"
                  :rows="2"
                  v-model="form.user.address"
                  placeholder="No 5, Apabio Str, Lagos, Nigeria"
                  id="address"
                ></el-input>
              </div>
              <div
                class="form-group"
                style="display: flex: flex-flow: column; width: 45%; margin-left: 5%;"
              >
                <label style="text-align: left; padding: 0;" for="description"
                  >CC Emails</label
                >
                <el-input
                  type="textarea"
                  :rows="2"
                  v-model="form.user.ccEmails"
                  placeholder="me@arnergy.com, you@arnergy.com"
                  id="ccEmails"
                ></el-input>
              </div>
            </div>

            <button type="submit" @click="add" class="btn btn-primary mb-2">
              {{ loading ? "Loading..." : "Add" }}
            </button>
          </form>
        </div>
      </div>
    </vk-offcanvas>
  </div>
</template>
<script>
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { Autocomplete } from "element-ui";
import moment from "moment";
export default {
  name: "add-subs",
  props: {
    toggleAdd: {
      type: Function
    },
    getSubs: {
      type: Function
    },
    addOffCanvas: {
      type: Boolean,
      default: false
    },
    installationList: {
      type: Array
    }
  },
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete
  },
  computed: {
    getCurrentMonth: function() {
      const date = moment().format("MMMM YYYY");
      return date;
    }
  },
  data: function() {
    return {
      loading: false,
      form: {
        amount: "",
        title: "",
        description: "",
        orderVat: "7.5",
        installation: null,
        paymentModel: "",
        ccEmails: "",
        user: {
          ccEmails: "",
          address: ""
        },
        filterDate: [],
        location: "",
        sendDate: ""
      }
    };
  },
  methods: {
    logDate() {
      console.log({ data: this.form.filterDate });
    },
    add(e) {
      e.preventDefault();
      let ctx = this;
      const HTTP = ctx.$httpUtils.instance;
      console.log({ form: ctx.form });
      if (
        ctx.form.installation == null ||
        ctx.form.amount < 5 ||
        ctx.form.location == "" ||
        ctx.form.paymentModel == null ||
        ctx.form.user.address == "" ||
        ctx.form.sendDate == "" ||
        ctx.form.filterDate.length < 2
      ) {
        alert("All fields are required");
        return;
      }
      let data = ctx.form;
      delete data.installation;

      ctx.loading = true;
      const url = "/subscriptionsMgr";
      HTTP.post(url, data)
        .then(response => {
          console.log({ response });
          ctx.getSubs();
          ctx.form = {
            amount: "",
            title: "",
            description: "",
            orderVat: "7.5",
            installation: null,
            paymentModel: "",
            ccEmails: "",
            user: {
              address: ""
            },
            filterDate: [],
            location: "",
            sendDate: ""
          };
          ctx.loading = false;
        })
        .catch(error => {
          ctx.loading = false;
          var errorMsg = error.response.data.error.message;
          console.log(JSON.stringify(error));
          console.log({ errorMsg });
          alert(errorMsg);
        });
    },
    installationSearch(queryString, cb) {
      let installationList = this.installationList;
      var results = queryString
        ? installationList.filter(installation =>
            this.createFilter(queryString, installation)
          )
        : installationList;
      cb(results);
    },
    createFilter(queryString, installation) {
      // console.log({ name: installation });
      return (
        `${installation.name} - ${installation.CID}`
          .toLowerCase()
          .indexOf(queryString.toLowerCase()) > -1
      );
    },
    noPaymentModelChange(paymentModel) {
      let ctx = this;

      ctx.form.description = ctx.getDescription(paymentModel);
      ctx.form.title = ctx.getTitle(paymentModel);
    },
    contactSelected(installation) {
      let ctx = this;
      let { form } = ctx;
      let { deviceRequest, user, locations } = installation;
      console.log({ location: deviceRequest });

      let paymentModel = deviceRequest.paymentModel;
      if (paymentModel == "LO" || paymentModel == "ES") {
        form.paymentModel = paymentModel;
        form.description = ctx.getDescription(paymentModel);
        form.title = ctx.getTitle(paymentModel);
        form.userId = user.id;
        form.CID = installation.CID;
        form.installationId = installation.id;
        // User
        form.user.firstName = user.firstName;
        form.user.lastName = user.lastName;
        form.user.email = user.email; //
        form.user.ccEmails = user.ccEmails; //
        form.user.id = user.id; //
        // Location
        form.location =
          typeof locations == "undefined" ? "" : locations.streetRoute;

        ctx.form = form;
      } else {
        ctx.form = {
          amount: "",
          title: "",
          description: "",
          orderVat: "7.5",
          installation: null,
          paymentModel: "",
          ccEmails: "",
          user: {
            address: ""
          },
          filterDate: [],
          location: ""
        };
        alert("Only ES and LO are Allowed");
      }
    },
    getDescription(paymentModel) {
      let desc = "";
      let md = paymentModel != null ? paymentModel.toUpperCase() : "";
      switch (md) {
        case "ES":
          desc = `Subscription for the month of ${this.getCurrentMonth}`;
          break;
        case "OS":
          desc = "OUTRIGHT SALE";
          break;
        case "LO":
          desc = `Repayment for the month of ${this.getCurrentMonth}`;
          break;
        default:
          desc = "MONTHLY SUBSCRIPTION";
          break;
      }
      return desc;
    },
    getTitle(paymentModel) {
      let title = "";
      let md = paymentModel != null ? paymentModel.toUpperCase() : "";
      switch (md) {
        case "ES":
          title = "ENERGY AS A SERVICE SUBSCRIPTION";
          break;
        case "OS":
          title = "OUTRIGHT SALE";
          break;
        case "LO":
          title = "LEASE TO OWN REPAYMENT";
          break;
        default:
          title = "MONTHLY SUBSCRIPTION";
          break;
      }
      return title;
    }
  },
  created() {
    let ctx = this;
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/subsmanager/add.vue